import { buildMarketFeedWebsocketUrl } from './marketFeedClient';

const MARKET_FEED_REALTIME_PATH = '/realtime';

export const marketFeedRealtimeWebsocketUrl = buildMarketFeedWebsocketUrl({
  path: MARKET_FEED_REALTIME_PATH,
});
